export default "__VITE_ASSET__KiNZRH5B__"